import React from "react";
import { message } from "antd";

interface AlertMessageProps {
  text: string;
  subText?: string;
  type: "success" | "error" | "info" | "warning" | "loading" | undefined;
  duration?: number; // Optional duration in seconds
}

const AlertMessage = ({
  text,
  subText,
  type,
  duration = 3,
}: AlertMessageProps) => {
  message.destroy();

  const content = (
    <div>
      <div style={{ fontWeight: 600, textAlign: "left" }}>{text}</div>

      {subText && (
        <div
          style={{
            fontSize: "var(--font-size-sm)",
            marginTop: "0px",
            color: "#666",
            textAlign: "left"
          }}>
          {subText}
        </div>
      )}
    </div>
  );

  switch (type) {
    case "success":
      message.success(content, duration);
      break;

    case "error":
      message.error(content, duration);
      break;

    case "info":
      message.info(content, duration);
      break;

    case "warning":
      message.warning(content, duration);
      break;

    case "loading":
      message.loading(content, duration);
      break;

    default:
      console.error("Invalid message type");
  }
};

export default AlertMessage;
